
import React, {Component} from 'react';
import {Modal,Button,ButtonToolbar,FormControl,ControlLabel} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import Select from 'react-select'
import SelectFormInline from '../../../component/element/SelectFormInline'
import DatePicker from '../../../component/element/DatePicker'
import AlertPopupStore from '../../../component/element/AlertPopupStore'
import HrStore from '../../../stores/HrStore'
import 'react-date-picker/index.css'
import moment from 'moment'
import DayPicker from 'react-day-picker';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import {asyncContainer, Typeahead} from 'react-bootstrap-typeahead';
const AsyncTypeahead = asyncContainer(Typeahead);


var th = require('moment/locale/th')

const LABEL = { nextMonth: '来月', previousMonth: '前月' }
const currentYear = new Date().getFullYear();
const toMonth = new Date(currentYear+1, 0, 1, 0, 0);
const fromMonth = new Date(currentYear - 20, 11, 31, 23, 59);

const DEDUCTION_LIST = [{label:'ประกันสังคม'},{label:'เงินสะสม'},{label:'ขาดงาน'},{label:'มาสาย'}]
// Component will receive date, locale and localeUtils props
function YearMonthForm({ date, localeUtils, onChange }) {
  const months = localeUtils.getMonths('th');
  console.log('date',date)
  const years = [];
  for (let i = toMonth.getFullYear(); i >= fromMonth.getFullYear(); i -= 1) {
    years.push(i);
  }

  const handleChange = function handleChange(e) {
    const { year, month } = e.target.form;
    onChange(new Date(year.value, month.value));
  };

  return (
    <form className="DayPicker-Caption">
      <select name="month" onChange={handleChange} value={date.getMonth()}>
        {months.map((month, i) => <option key={i} value={i}>{month}</option>)}
      </select>
      <select name="year" onChange={handleChange} value={date.getFullYear()}>
        {years.map((year, i) => (
          <option key={i} value={year}>
            {year+543}
          </option>
        ))}
      </select>
    </form>
  );
}

function Navbar({
  nextMonth,
  previousMonth,
  onPreviousClick,
  onNextClick,
  className,
  localeUtils,
}) {
  const months = localeUtils.getMonths('th');
  const prev = months[previousMonth.getMonth()];
  const next = months[nextMonth.getMonth()];
  return (
    <div className={className} style={{ fontSize: '.75em' }}>
      <span
        style={{ float: 'left', cursor: 'pointer' }}
        onClick={() => onPreviousClick()}
      >
        ← {prev.slice(0, 3)}
      </span>
      <span
        style={{ float: 'right', cursor: 'pointer' }}
        onClick={() => onNextClick()}
      >
        {next.slice(0, 3)} →
      </span>
    </div>
  );
}
//http://react-day-picker.js.org/examples/?yearNavigation
class EmployeeDeductionTablePopup extends Component {
  constructor(...args){
    super(...args)
    let dt = new Date();
    let year = dt.getFullYear()*1+543
    this.state = {loading:true,emId:'',changeFlag:false,year:year,periodText:'',statusText:'',tableList:[],month:new Date(2017, 5, 23)}
    
    
  }

  loadDeduction(emId,start,end,periodText){
    this.setState({emId:emId,tableList:[],start:start,end:end,periodText:periodText,changeFlag:false,loading:true})
    let that = this
    HrStore.loadDeductionOnPeriod(emId,start,end,function(result){

      that.setState({tableList:result.data,editTableList:new Array(result.data.length).fill(false),loading:false})
      
    },function(){

    })
  }

  getCountOfAbsence(start,end,format){
    let startDate = moment(start, format)
    let endDate = moment(end, format)  
    console.log('start',start,end)
    const range = moment.range(startDate, endDate);
 
    const acc = Array.from(range.by('day', { exclusive: false }));
    
    let workAcc = acc.reduce((rresult,item)=>{
      let dow = item.day()
      if(dow!==0)
        rresult.push(item)
      return rresult
    },[])
    //console.log('countOfWork',workAcc)
    return workAcc.length
  }


    onHide(){
      let {changeFlag} = this.state
      this.props.onHide(changeFlag);
    }

    getYearOptions(){
      let options = []
      var dt = new Date();
      for(let i=(dt.getFullYear()*1+543);i>=2558;i--){
        options.push({label:i,value:i})
      }
      return options;
    }

    onYearChange(e){
      let year = e.value,that = this
      that.setState({year:year,loading:true})
      HrStore.loadHoliday(year,function(result){
        that.setState({loading:false,tableList:result.result})
        window.datepicker('#box-holiday');
      },function(error){

      })
    }

    onSaveClick(){
      let {year,tableList,statusText} = this.state
      let that = this
      HrStore.saveHoliday(year,tableList,function(result){
        if(result.status==='OK'){
          that.setState({statusText:'บันทึกเรียบร้อย'})
          setTimeout(function(){ that.setState({statusText:''}) }, 3000);
        }
      },function(){

      })
    }

    onSaveRow(row){
      let {emId,tableList,editTableList} = this.state

      editTableList[row] = false

      this.setState({editTableList:editTableList,statusText:'กำลังบันทึก...'})
      let that = this
      let item = tableList[row]
      let postData = {id:item[0],absence_date:item[1],end_date:item[2],duration:item[3],absence_type:item[4],absence_wage:item[5],remark:item[6]}
      HrStore.saveAbsence(emId,postData,function(result){
        console.log('result ',result)
        if(item[0]==='' && result.status=='OK'){
          tableList[row][0] = result.id
        }
        that.setState({tableList:tableList,statusText:'บันทึกเรียบร้อย',changeFlag:true})
        setTimeout(function(){ that.setState({statusText:''}) }, 3000);        
      },function(){

      })
    }

    onEditRow(row){
      let {editTableList} = this.state

      editTableList[row] = true

      this.setState({editTableList:editTableList})
    }

    onDeleteRow(row){
      let {emId,tableList,editTableList} = this.state
      let that = this
      let absenceId =  tableList[row][0]
      
      if(absenceId!==''){
        AlertPopupStore.confirm("ยืนยันต้องการลบข้อมูลในระบบทิ้ง?",'ยืนยัน',function(){
          
            that.setState({statusText:'กำลังลบข้อมุล...'})
            HrStore.deleteAbsence(emId,absenceId,function(result){
              tableList.splice(row, 1);
              editTableList.splice(row,1);
              that.setState({tableList:tableList,editTableList:editTableList,statusText:'ลบข้อมูลเรียบร้อย',changeFlag:true})
              setTimeout(function(){ that.setState({statusText:''}) }, 3000);        
            },function(error){
              that.setState({statusText:error})
            })
          
        })   
      }else{
          tableList.splice(row, 1);
          editTableList.splice(row,1);
          that.setState({tableList:tableList,editTableList:editTableList})
        }   
      
    }

    getNormalDate(dateString){
      let res = dateString.split("/");
      return res[0]+"/"+res[1]+"/"+(res[2]*1-543)
    }

    getEraDate(dateString){
      let res = dateString.split("/");
      return res[0]+"/"+res[1]+"/"+(res[2]*1+543)
    }

    calculatePeriod(tableList,index){
      let start = tableList[index][1]
      let end   = tableList[index][2]
      if(start!==''&& end!==''){
        tableList[index][3] = this.getCountOfAbsence(this.getNormalDate(start),this.getNormalDate(end),'DD/MM/YYYY')+""
      }
      
    }

    validatePeriod(tableList,index){
      let {start,end} = this.state
      let startVal = tableList[index][1]
      let endVal   = tableList[index][2]
      if(startVal!==''&& endVal!==''){
        
        let startRange = moment(start,'YYYY/MM/DD')
        let endRange = moment(end,'YYYY/MM/DD')
        if(startRange.isAfter(moment(this.getNormalDate(startVal),'DD/MM/YYYY'))){
          
          AlertPopupStore.warn(startVal+" เกินช่วงเวลาเริ่มต้น "+this.getEraDate(startRange.format('DD/MM/YYYY'))+"?",'แจ้งเตือน',function(){
          })
          return false
        }
        if(endRange.isBefore(moment(this.getNormalDate(endVal),'DD/MM/YYYY'))){
          
          AlertPopupStore.warn(endVal+" เกินช่วงเวลาสุดท้าย "+this.getEraDate(endRange.format('DD/MM/YYYY'))+"?",'แจ้งเตือน',function(){
          })
          return false
        }
        return true;
      }else{
        return true;
      }
    }

    onDateChange(index,col,dateString,dateMoment){
      console.log('e',dateString,dateMoment)
      let {tableList} = this.state      
      let before = tableList[index][col]
      tableList[index][col] = dateString
      if(this.validatePeriod(tableList,index)){
        
        this.calculatePeriod(tableList,index);
        this.setState({tableList:tableList})
      }else{
        tableList[index][col] = before
      }
    }

    onTextChange(index,col,e){
      let {tableList} = this.state
      tableList[index][col] = e.target.value
      this.setState({tableList:tableList})
    }

    onSelectChange(index,col,value){
      let {tableList} = this.state
      tableList[index][col] = value.value
      this.setState({tableList:tableList})
    }

    onAddRow(){
      let {tableList,editTableList} = this.state
      tableList.push(new Array(4).fill(''))
      editTableList.push(true)
      this.setState({tableList:tableList})
    }
// <DayPickerInput
//         labels={LABEL}
//         locale={'th'}
//         localeUtils={MomentLocaleUtils}        
//         placeholder="DD/MM/YYYY"
//         onDayChange={day => console.log(day)}
//       />
    onYearMonthChange(month){
        this.setState({ month });
    }

    onInputChange(index,col,e){
      let dataVal = ''
      let {tableList} = this.state
      
      
      if(e.length==0){
        dataVal = ''
      }else{
        if(typeof e[0].removeLabel!=='undefined'){
          //Remove array
        }else{
          dataVal = e.length>0?e[0].label:''
        }
      }
      tableList[index][col] = dataVal
      this.setState({tableList:tableList})
    }


    renderDatePickerInput(item){
      return (
        
      <DayPicker                
          labels={LABEL}
          locale={'th'}
          localeUtils={MomentLocaleUtils}   
          month={this.state.month}
          fromMonth={fromMonth}
          toMonth={toMonth}    
          todayButton="เลือกวันนี้"      
          renderDay={day => day.getDate().toLocaleString('th')}
          captionElement={
            <YearMonthForm onChange={this.onYearMonthChange.bind(this)} />
          }  
          navbarElement={<Navbar />}        
        />
      )
    }

    renderDateField(item,index,col){
      //console.log('display',item.display_date)
      return (
        <DatePicker style={{display:'inline-block'}}
            showIcon={true}
            showFooter={true}
            popPlacement='bottom'
            buddhistEra
            value={item} 
            onChange={this.onDateChange.bind(this,index,col)}/>
      )
    }

    getWageOptions(){
      return [
        {value:'0',label:'ไม่หักค่าแรง'},
        {value:'0.5',label:'หักค่าแรง ครึ่งแรง'},
        {value:'1',label:'หักค่าแรง 1 แรง'},
        {value:'1.5',label:'หักค่าแรง 1 แรงครึ่ง'},
      ]
    }

    getReasonOptions(){
      return [
        {value:"SICK",label:"ลาป่วย"},
        {value:"BUSINESS",label:"ลากิจ"},
        {value:"DISAPPEAR",label:"ขาด"}
      ]
    }

    getDuration(){
      return [        
        {value:"0.5",label:"ครึ่งวัน"},
        {value:"1",label:"1 วัน"},
        {value:"2",label:"2 วัน"},
        {value:"3",label:"3 วัน"},
        {value:"4",label:"4 วัน"},
        {value:"5",label:"5 วัน"},
        {value:"6",label:"6 วัน"},
        {value:"7",label:"7 วัน"},
        {value:"8",label:"8 วัน"},
        {value:"9",label:"9 วัน"},
        {value:"10",label:"10 วัน"},
        {value:"11",label:"11 วัน"},
        {value:"12",label:"12 วัน"},
        {value:"13",label:"13 วัน"}
      ]
    }

    renderEditButtonToolbar(row){
      let {editTableList} = this.state
      let showSave = editTableList[row]
      return (
        
        <ButtonToolbar>
          <Button style={{display:(showSave)?'block':'none'}} bsStyle='primary' onClick={this.onSaveRow.bind(this,row)}><FontAwesome name='save'/>บันทึก</Button>
          <Button style={{display:(!showSave)?'block':'none'}} bsStyle='default' onClick={this.onEditRow.bind(this,row)}><FontAwesome name='pencil'/>แก้ไข</Button>
          <Button bsStyle='danger' onClick={this.onDeleteRow.bind(this,row)}><FontAwesome name='trash'/>ลบ</Button>
        </ButtonToolbar>
  
      )
    }

    renderItemCol(item,index){
      if(index===4){
        let resultText = '';
        this.getReasonOptions().map((ritem,rindex)=>{
          if(ritem.value==item){
            resultText = ritem.label
          }
        })
        return (<span>{resultText}</span>)
      }else if(index===5){
        let resultText = '';
        this.getWageOptions().map((ritem,rindex)=>{
          if(ritem.value==item){
            resultText = ritem.label
          }
        })
        return (<span>{resultText}</span>)        
      }else{
        return (<span>{item}</span>)
      }
    }

    renderReadOnlyCol(rowItem,rowIndex){
      return rowItem.map((item,index)=>(        
        <td key={index} className="data-column">          
          {(index===7)?this.renderEditButtonToolbar(rowIndex):this.renderItemCol(item,index)}          
        </td>
      ))
    }

    renderReadOnlyRow(item,index){
      return (
        <tr key={index} className="data-row">   
          {this.renderReadOnlyCol(item,index)}
        </tr>
      )
    }

    renderMenuItemChildren(label){
      console.log('renderMenuItemChildren',label)
      if(typeof label.removeLabel!=='undefined')
        return (<div><span className='text-red'>ลบรายการ : </span>{label.label}</div>)
      else
        return (<div>{label.label}</div>)
    }

    renderEditRow(item,index){
      return (
        <tr key={index} className="data-row">          
            <td className="data-column">
              {item[0]}
            </td>            
            <td className="data-column " >                
                <Typeahead     
                  newSelectionPrefix={'เพิ่มรายการ : '}              
                  allowNew={true}                         
                  selected={[{label:item[1],removeLabel:true}]}
                  options={DEDUCTION_LIST}  
                  renderMenuItemChildren={this.renderMenuItemChildren.bind(this)}  
                  onChange={this.onInputChange.bind(this,index,1)}                          
                /> 
            </td>
            <td className="data-column " style={{width:'180px'}}>
                <FormControl value={item[2]} className='text-right'  onChange={this.onTextChange.bind(this,index,2)}/>
            </td>            
            <td className="data-column">
                <FormControl value={item[3]}  onChange={this.onTextChange.bind(this,index,3)}/>
            </td>
            <td className="data-column" style={{width:'180px'}}>
              {this.renderEditButtonToolbar(index)}
            </td>
        </tr>
      )
    }

    renderTableData(){
      let {tableList,editTableList} = this.state
      if(tableList.length===0){
        return (<tr><td colSpan={5}>ไม่มีรายการในช่วงเวลานี้</td></tr>)
      }

      return tableList.map((item,index)=>{
       if(editTableList[index]){
         return this.renderEditRow(item,index)
       }else{
         return this.renderReadOnlyRow(item,index)
       }
      })
    }

    renderHolidayForm(){
      let {year,loading} = this.state
      return (
        <div className="box box-default " id='box-holiday'>
            <div className="box-body">
                <div className="row" style={{display:'none'}}>
                    <div className="navbar-form navbar-left">
                        <SelectFormInline label='ประจำปี' value={year}
                          options={this.getYearOptions()}
                          onChange={this.onYearChange.bind(this)}  clearable={false}/>
                    </div>
                </div>
                <table className="table table-responsive table-bordered-solid">
                    <thead>
                        <tr>
                            <th >ID</th>
                            <th >รายการ</th>
                            <th style={{width:'180px'}}>จำนวนเงิน</th>
                            <th>หมายเหตุ</th>
                            <th style={{width:'180px'}}>แก้ไข/บันทึก</th>
                        </tr>
                    </thead>
                    <tbody>
                      {this.renderTableData()}
                    </tbody>

                </table>
                <Button bsStyle={null} className="btn  bg-olive " onClick={this.onAddRow.bind(this)}>+เพิ่มรายการ</Button>
            </div>
            <div className="overlay" style={{display:(loading?'block':'none')}}>
              <i className="fa fa-refresh fa-spin"></i>
            </div>
            <div className="box-footer">
                <div className=" pull-right">
                  <ButtonToolbar>                    
                    <Button bsStyle="default" onClick={this.props.onHide}><FontAwesome name="close"/>&nbsp;ปิดหน้าต่าง</Button>
                  </ButtonToolbar>
                </div>
                <div className='pull-left' style={{lineHeight:'36px'}}>
                  <ControlLabel> {this.state.statusText} </ControlLabel>
                </div>  
            </div>
                      
        </div>
      )
    }
    render(){
      let {periodText} = this.state
      let label  = 'รายการหักเงิน '+periodText
      return (
        <Modal show={this.props.show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="midwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{label}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderHolidayForm()}
          </Modal.Body>
       </Modal>
      )
    }
}

export default EmployeeDeductionTablePopup






// WEBPACK FOOTER //
// ./src/view/hr/deduction/EmployeeDeductionTablePopup.js